import * as React from 'react';
import { ComponentLayout } from 'src/components/common/modules/component-layout/code-split/component-layout-component';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { V3FourUpCardsModuleComponent } from './code-split/v3-four-up-cards-module-component';
import { V3FourUpCardCarouselModuleComponent } from '../v3-four-up-card-carousel-module/code-split/v3-four-up-card-carousel-module-component';

const V3FourUpCardsModule: React.FC<ComponentLayoutType<any>> = (props) => {
  return (
    <ComponentLayout {...props}>
      {props?.data?.cardStyle && props?.data?.cardStyle === 'Video' ? (
        <V3FourUpCardCarouselModuleComponent />
      ) : (
        <V3FourUpCardsModuleComponent />
      )}
    </ComponentLayout>
  );
};

export default V3FourUpCardsModule;
